import { render, staticRenderFns } from "./PromoPopupContent.vue?vue&type=template&id=143ebd52&scoped=true&"
import script from "./PromoPopupContent.vue?vue&type=script&lang=js&"
export * from "./PromoPopupContent.vue?vue&type=script&lang=js&"
import style0 from "./PromoPopupContent.vue?vue&type=style&index=0&id=143ebd52&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143ebd52",
  null
  
)

export default component.exports